import { render, staticRenderFns } from "./TranslateButton.vue?vue&type=template&id=73408fa9&scoped=true"
import script from "./TranslateButton.vue?vue&type=script&lang=js"
export * from "./TranslateButton.vue?vue&type=script&lang=js"
import style0 from "./TranslateButton.vue?vue&type=style&index=0&id=73408fa9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73408fa9",
  null
  
)

export default component.exports